// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyARvnGukVhXgpqCuxtGNcaNTtI7wp1iOPM",
  authDomain: "arya-dreamjob.firebaseapp.com",
  projectId: "arya-dreamjob",
  storageBucket: "arya-dreamjob.appspot.com",
  messagingSenderId: "412776367352",
  appId: "1:412776367352:web:91d2e8a87a073e9700270d",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
